// @flow
import React from "react";
import { connect } from "react-redux";
import { useI18n } from "@quantum/i18n";
import SelectInput from "../../../comum/SelectInput";
import {
  selecionarIndices,
  getIndices,
  getBenchmarksPersonalizados,
  getIndicesSelecionados,
} from "../../../../state";
import { propOr, sort } from "ramda";

const SelecaoIndices = (props: *) => {
  const { translate } = useI18n();

  return (
    <div className="ConfiguracaoMedida">
      <label className="ConfiguracaoMedida__label">
        {translate("maiusculas.indice")}
      </label>
      <SelectInput
        alwaysOpen={true}
        portal={false}
        size={6}
        multiple
        campoDescricao="nomeTraduzido"
        campoId="nome"
        {...props}
      />
    </div>
  );
};

export default connect(
  state => ({
    options: [
      ...sort((indiceA, indiceB) =>
        propOr("", "value", indiceA).localeCompare(propOr("", "value", indiceB))
      )(getIndices(state)),
      ...sort((benchmarkPersonalizadoA, benchmarkPersonalizadoB) =>
        propOr("", "value", benchmarkPersonalizadoA).localeCompare(
          propOr("", "value", benchmarkPersonalizadoB)
        )
      )(getBenchmarksPersonalizados(state)),
    ],
    value: getIndicesSelecionados(state),
  }),
  { onChange: selecionarIndices }
)(SelecaoIndices);
